export const tieredProviderLocations = (providerLocations): string[] =>
  providerLocations?.filter((location) => location?.isTieredProvider === true);

export const acoProviderLocations = (providerLocations): string[] =>
  providerLocations?.filter(
    (location) =>
      Array.isArray(location?.acoProvider) && location?.acoProvider.length > 0
  );
export const getAddress = (address: any): string => {
  const addressLine = address?.line?.[0] ?? '';
  const city = address?.city ?? '';
  const state = address?.state ?? '';

  return [addressLine, city, state].filter(Boolean).join(', ');
};
export const defaultBooleanToFalse = (bool?: boolean | null): boolean =>
  bool ?? false;
export type Maybe<T> = T | null | undefined;

export const colorAndText = (val: string): { color: string; text: string } => {
  if (['A', 'B', 'C', 'D'].includes(val)) {
    return { color: '#007000', text: 'belowAverage' };
  }
  if (val === 'E') {
    return { color: '#196ECF', text: 'average' };
  }
  if (val === 'F' || val === 'G') {
    return { color: '#990000', text: 'aboveAverage' };
  }
  return { color: '', text: '' };
};
